import { bind } from 'decko';
import { inject } from 'dependable-react';
import { Book, OptionValue } from '../state/models';

import { LOADER_ANIMATION_LENGTH } from '../consts/animations';
import { Gender } from '../enums/Gender';
import { API_CLEINT_TOKEN, APP_DATA_TOKEN } from './InjectTokens';
import { pushGtmData } from '../utils/gtm';
import { toJS } from 'mobx';

interface IDefaultParams {
  childGender?: string;
}

export class BookService {
  private appState = inject(APP_DATA_TOKEN);
  private apiClient = inject(API_CLEINT_TOKEN);

  @bind
  public async load(bookId: number, defaultParams: IDefaultParams) {
    if (!bookId) {
      throw new Error('Book ID was not specified during boot');
    }

    return this.apiClient.delayedGet(`/personalizacija/knjige/${bookId}`, LOADER_ANIMATION_LENGTH).then((res) => {
      // @ts-ignore
      const book = res.book;
      // @ts-ignore
      const mainChar = res.book.avatars.find(({ mainCharacter }) => mainCharacter);

      // HACK: this is bc we handle genders in a wrong way.
      if (mainChar && defaultParams.childGender) {
        mainChar.genderId = defaultParams.childGender === 'f' ? Gender.FEMALE : Gender.MALE;
        mainChar.defaultPreview.sex = defaultParams.childGender;
      }

      this.appState.add(book, Book);
    });
  }

  @bind
  public preloadPages() {
    // const currentLang = this.appState.currentLanguage;
    // const pageImages = this.appState.pageImages
    //   .map(({ backgrounds }) => backgrounds[currentLang] || backgrounds.shared)
    //   .filter(Boolean)
    //   .map(({ smallUrl }) => smallUrl);
    const avatarImages = this.appState.pageImages
      .map(({ avatars }) => avatars)
      .filter(Boolean)
      .map((o) => Object.keys(o).map((key) => o[key]))
      .map((o) => o.map((i) => i))
      .reduce((acc, curr) => [...acc, ...curr], [])
      .reduce((acc: any, curr: any) => [...acc, ...curr], [])
      .map((o: any) => o.image.smallUrl);
    const thumbs = this.appState
      .findAll(OptionValue)
      .filter(({ pickerValue }) => typeof pickerValue === 'object')
      .map(({ pickerValue }) => pickerValue.thumbnail.medium.url)
      .filter(Boolean);

    for (const url of [...avatarImages, ...thumbs]) {
      const image = new Image();
      image.src = url;
    }
  }

  @bind
  public async submit(later: boolean) {
    const book = this.appState.bookPayload;
    const orderId = this.appState.orderId;
    let url: string;

    /* pushGtmData({
      event: 'add_to_cart',
      korak: { items: [{ step: `add_to_cart` }] },
    }); */

    console.log(this.appState);

    const { translations, currentLanguage, price } = this.appState;
    const name: string = translations[currentLanguage][`title`];

    type PriceObject = {
      [key: string]: any; // 👈️ variable key
    };

    const pr: PriceObject = toJS(price);
    console.log(pr.shopTvornicasnovaHr);

    if (later) {
      pushGtmData({
        event: 'save_for_later',
        ecommerce: {
          items: [
            {
              item_id: this.appState.bookId,
              item_name: name,
              item_category: 'Book',
              price: pr.shopTvornicasnovaHr,
            },
          ],
        },
      });
      url = `/personalization/order-items/${orderId}?save_for_later=true`;
    } else {
      pushGtmData({
        event: 'add_to_cart',
        ecommerce: {
          items: [
            {
              item_id: this.appState.bookId,
              item_name: name,
              item_category: 'Book',
              price: pr.shopTvornicasnovaHr,
            },
          ],
        },
      });
      url = `/personalization/order-items/${orderId}`;
    }

    return this.apiClient.patch(url, JSON.stringify(book));
  }

  @bind
  public async uploadPhoto(image: Blob, originalFileName: string) {
    const orderId = this.appState.orderId;
    const form = new FormData();
    form.append('image', image, originalFileName);

    return this.apiClient.post(`/personalizacija/stavka-narudzbe/${orderId}/upload-slike`, form);
  }

  @bind
  public async getDedicationText(_bookID?: number) {
    const bookID = _bookID || this.appState.orderId;

    this.apiClient
      .get(`/personalizacija/posveta?book_id=${bookID}`)
      .then((res) => {
        this.appState.dedications = res.dedications;
      })
      .catch((e) => {
        console.log('error: ', e);
      });
  }
}
